import request from '../../service';
import Exported from '../../service/endpoints';
import config from '../../service/env';

export const getUserProfile = (data) => {
  return request({
    url: Exported.Endpoints.getUserProfile,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const updateUserProfile = (data) => {
  return request({
    url: Exported.Endpoints.updateUserProfile,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const getProfileAddress = (data) => {
  return request({
    url: Exported.Endpoints.getProfileAddress,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.traceabilityServiceApi,
  });
};

export const updateAddress = (data, addressId) => {
  return request({
    url: `${Exported.Endpoints.address}/${addressId}`,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.traceabilityServiceApi,
  });
};

export const createAddress = (data) => {
  return request({
    url: Exported.Endpoints.address,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.traceabilityServiceApi,
  });
};

export const getTrainingList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.trainingModule + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const updateLessonCompletionStatus = (data) => {
  return request({
    url: Exported.Endpoints.trainingModule,
    method: Exported.APIMethods.POST,
    data,
  });
};

export const getTrainingByID = (id) => {
  return request({
    url: `${Exported.Endpoints.trainingModule}/${id}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getLessonListByID = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getLessonsByID + id + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const createTrainingModule = (data) => {
  return request({
    url: Exported.Endpoints.trainingModule,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const updateTrainingModule = (data, id) => {
  return request({
    url: `${Exported.Endpoints.trainingModule}/${id}`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const deleteTrainingModule = (data) => {
  return request({
    url: `${Exported.Endpoints.trainingModule}/${data?.id}`,
    method: Exported.APIMethods.DELETE,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const createLessonModule = (data) => {
  return request({
    url: Exported.Endpoints.lessonModule,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const updateLessonModule = (data) => {
  return request({
    url: `${Exported.Endpoints.lessonModule}/${data?.id}`,
    method: Exported.APIMethods.PATCH,
    data,

    baseUrl: config.diffusionServiceApi,
  });
};

export const getLessonModule = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.lessonModule + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getLessonByID = (data, id) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: `${Exported.Endpoints.getLessonById}/${id}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const deleteLessonModule = (data) => {
  return request({
    url: `${Exported.Endpoints.lessonModule}/${data?.id}`,
    method: Exported.APIMethods.DELETE,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getEventsList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getEvent + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getCollectionsList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getCollections + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.traceabilityServiceApi,
  });
};

// New function specifically for file exports
export const exportEventsList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getEvent + queryString,
    method: Exported.APIMethods.GET,
    data,
    responseType: 'blob',
    baseUrl: config.diffusionServiceApi,
    sendRes: true,
  });
};

export const getApprovalsList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.approvalStatus + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getURLbykey = (data) => {
  return request({
    url: Exported.Endpoints.getUrlByKey + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.documentServiceApi,
  });
};

export const getCalendarEventList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.livelihoodCalendarEvent + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getAttendanceByEventId = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getAttendanceById + id + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const AttendanceByEventId = (id) => {
  return request({
    url: Exported.Endpoints.getAttendanceById + id,
    method: Exported.APIMethods.GET,
  });
};

export const updateAttendance = (data) => {
  return request({
    url: Exported.Endpoints.updateAttendance,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

// reportsAnalytics
export const getReportEventList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.reportEvent + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};
export const getReportTrainingList = (data) => getReportEventList(data);
export const getReportSurveyList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.reportSurvey + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getReportsAnalyticsStats = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.reportsAnalytics + queryString,
    method: Exported.APIMethods.GET,
    data,
  });
};

export const getUploadReports = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.UploadReport + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.documentServiceApi,
  });
};

export const postUploadReports = (data) => {
  return request({
    url: Exported.Endpoints.PostUpload,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.documentServiceApi,
  });
};

export const getExportData = (data) => {
  return request({
    url: Exported.Endpoints.downloadReports,
    method: Exported.APIMethods.POST,
    data,
    responseType: 'blob',
    baseUrl: config.diffusionServiceApi,
    sendRes: true,
  });
};

export const getParticipantCountForEventIds = (data) => {
  return request({
    url: Exported.Endpoints.getParticipantCountForEventIds,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getParticipantList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.participants + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getParticipantReport = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.participantReport + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getEventByID = (id) => {
  return request({
    url: Exported.Endpoints.getEventById + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const deleteEventByID = (id) => {
  return request({
    url: Exported.Endpoints.deleteEvent + id,
    method: Exported.APIMethods.DELETE,
  });
};

export const patchEventByID = (id, data) => {
  return request({
    url: `${Exported.Endpoints.getEvent}/${id}`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};
export const patchEventPhaseByID = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.eventPhase + queryString,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const createEventSubmit = (data) => {
  return request({
    url: Exported.Endpoints.createEvent,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const createParticipantSubmit = (data) => {
  return request({
    url: Exported.Endpoints.participantEnrollment,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};
export const bulkParticipantSubmit = (data) => {
  return request({
    url: Exported.Endpoints.bulkParticipant,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
    timeout: 0,
  });
};

export const getParticipantByID = (id) => {
  return request({
    url: Exported.Endpoints.getParticipantById + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const patchParticipantByID = (id, data) => {
  return request({
    url: Exported.Endpoints.participantEnrollment + id,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const deleteParticipantByID = (id) => {
  return request({
    url: Exported.Endpoints.deleteParticipant + id,
    method: Exported.APIMethods.DELETE,
  });
};

export const postBulkInvite = (data) => {
  return request({
    url: Exported.Endpoints.bulkInvite,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};
export const getBulkInvite = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  const url = id
    ? Exported.Endpoints.getBulkInvite + id + queryString
    : Exported.Endpoints.getBulkInvite + queryString;
  return request({
    url: url,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getFarmerDataList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.farmerData + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getEventsListForGivenEventIds = (body) => {
  return request({
    url: Exported.Endpoints.getEventsListForGivenEventIds,
    method: Exported.APIMethods.POST,
    data: body,
    baseUrl: config.diffusionServiceApi,
  });
};

export const fetchUpdatedByUsers = (body) => {
  return request({
    url: Exported.Endpoints.fetchUpdatedByUsers,
    method: Exported.APIMethods.POST,
    data: body,
    baseUrl: config.identityServiceApi,
  });
};

export const postFarmerData = (data, body) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.farmerData + queryString,
    method: Exported.APIMethods.POST,
    data: body,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getDFApprovalList = (data, endPoint) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.dfApprovalList + endPoint + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const postConsentSurvey = (data) => {
  return request({
    url: Exported.Endpoints.fillConsentAnswer,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const postConsentSurveyOnly = (data) => {
  return request({
    url: Exported.Endpoints.fillConsentSurvey,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const putFarmerStatus = (data) => {
  return request({
    url: Exported.Endpoints.farmerUpdateStatus,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

// Farmer Journey

export const getFarmerJourney = (data, id) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: `${Exported.Endpoints.farmerJourney}/${id}${queryString}`,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

// Survey

export const getSurveyList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.surveyModule + queryString,
    method: Exported.APIMethods.GET,
    data,
  });
};
export const getSurveyByID = (id) => {
  return request({
    url: Exported.Endpoints.getSurveyByID + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};
export const getSurveyByEventID = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getSurveyByEventID + id + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getSurveyResponseByEventID = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.surveyResponse + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getDownloadSurveyTemp = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.downloadSurveySample + queryString,
    method: Exported.APIMethods.GET,
    responseType: 'blob',
    baseUrl: config.diffusionServiceApi,
  });
};
export const getDownloadSurveyRes = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  console.log({ queryString });
  return request({
    url: Exported.Endpoints.downloadSurveyAns + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};
export const getDownloadSurveyResponse = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.downloadSurevyResponse + queryString,
    method: Exported.APIMethods.GET,
    responseType: 'blob',
    baseUrl: config.diffusionServiceApi,
    sendRes: true,
  });
};

export const getDownloadBulkSurveyResponse = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.downloadBulkSurveyResponse + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
    responseType: 'blob',
    sendRes: true,
  });
};
export const patchSurveyByID = (id, data) => {
  return request({
    url: Exported.Endpoints.patchSurveybyID + id,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const postSendSurvey = (data) => {
  return request({
    url: Exported.Endpoints.sendSurvey,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};
export const fillSurvey = (data) => {
  return request({
    url: Exported.Endpoints.fillSurvey,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const insertSurveyResponseFromExcel = (formData, params) => {
  return request({
    url: Exported.Endpoints.insertSurveyResponseFromExcel,
    method: Exported.APIMethods.POST,
    data: formData,
    params,
    headers: { 'Content-Type': undefined },
    baseUrl: config.diffusionServiceApi,
  });
};

export const getSurveyListByTab = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.surveyListByTab + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const deleteSurveyById = (data) => {
  return request({
    url: Exported.Endpoints.deleteSurvey + data?.id,
    method: Exported.APIMethods.DELETE,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const createSurveyQuestion = (data) => {
  return request({
    url: Exported.Endpoints.surveyModule,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getSurveyHistoryForParticipantIds = (data) => {
  // data should be { participantIds: [array of ids] }
  return request({
    url: Exported.Endpoints.surveyHistory,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

// Collection Center

export const getCollectioncenter = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.collectioncenter + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const getRISSGroup = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.rissGroup + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const createCollectionCenter = (data) => {
  return request({
    url: Exported.Endpoints.createCollectionCenter,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.identityServiceApi,
  });
};

// Organisation

export const getOrganisation = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.organisation + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const parcingICNumber = (data) => {
  return request({
    url: Exported.Endpoints.parceICNumber,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getLocationList = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getLocation + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.traceabilityServiceApi,
  });
};

export const getAnalytics = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.analytics + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.analyticsServiceApi,
  });
};

export const getParticipantStatsReport = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.participantStats + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getOrganisationStatsReport = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.organisationStats + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const getEventsStatsReport = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.eventsStats + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getDiffusionDashboard = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.diffusionDashboard + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const postAddOrganisation = (data) => {
  return request({
    url: Exported.Endpoints.addOrganisation,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const getExportDiffFarmerJourney = (data) => {
  return request({
    url: Exported.Endpoints.exportCCFarmerJourney,
    method: Exported.APIMethods.POST,
    data,
    responseType: 'blob',
    baseUrl: config.diffusionServiceApi,
    sendRes: true,
  });
};

export const getparticipantsBySurveyId = (id, params = {}) => {
  return request({
    url: `${Exported.Endpoints.participantsBySurveyId}/${id}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
    params, //  pass { page, take }
  });
};

export const sendSurveyToParticipants = (data) => {
  return request({
    url: Exported.Endpoints.sendSurveyToParticipants,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const exportDifusionData = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.exportReportData + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.diffusionServiceApi,
  });
};

export const getSurveyListByEventId = (id) => {
  return request({
    url: Exported.Endpoints.surveyListByEventId + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
  });
};

export const fetchSurveysAndParticipantsByCondition = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.fetchSurveysAndParticipantsByCondition + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.diffusionServiceApi,
    data,
  });
};
